import clsx from "clsx";
import { Link } from "react-router-dom";

interface LinkItem {
  label: string;
  href?: string;
  icon?: React.ReactNode;
  active?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

function returnWithActive(links: LinkItem[], activePage: string): LinkItem[] {
  return links.map((link) => ({
    ...link,
    active: link.href === activePage,
  }));
}

export const businessProfileLinks = (activePage: string): LinkItem[] => {
  return returnWithActive(
    [
      { label: "Мой бизнес-профиль", href: "/dashboard" },
      { label: "Реквизиты", href: "/dashboard/requisites" },
      { label: "Сотрудники", href: "/dashboard/users" },
      { label: "Арендаторы", href: "/dashboard/renters" },
      { label: "Сервисное", href: "/dashboard/service/locks" },
      { label: "Интеграции", href: "/dashboard/accounting/integrations" },
    ],
    activePage,
  );
};

export const skudLinks = (
  activePage: string,
  lockSelected: boolean,
  onUnlock: () => void,
): LinkItem[] => {
  return returnWithActive(
    [
      { label: "Сервисные", href: "/dashboard/skud" },
      { label: "Замки", href: "/dashboard/locks" },
      { label: "Открыть", onClick: onUnlock, disabled: !lockSelected },
      {
        label: "Журнал",
        href: "/dashboard/skud/logs",
        disabled: !lockSelected,
      },
      {
        label: "Пароли",
        href: "/dashboard/skud/passcodes",
        disabled: !lockSelected,
      },
      {
        label: "Диспенсеры карт",
        href: "/dashboard/skud/devices",
      },
      {
        label: "Карты доступа",
        href: "/dashboard/skud/access-cards",
      },
    ],
    activePage,
  );
};

export interface LinksProps {
  links: LinkItem[];
}

export function Links({ links }: LinksProps) {
  return (
    <div className="flex flex-col gap-2 min-w-[240px] max-md:flex-grow quick-actions">
      {links.map((link) => {
        const baseClassName = clsx(
          "flex flex-row items-center gap-4 p-4 rounded-xl font-medium",
          link.active
            ? "text-primary bg-primary bg-opacity-10"
            : "text-foreground-600",
          link.disabled && "opacity-50 pointer-events-none cursor-not-allowed",
        );

        if (link.onClick) {
          return (
            <button
              key={link.label}
              onClick={link.disabled ? undefined : link.onClick}
              disabled={link.disabled}
              className={baseClassName}>
              {link.icon}
              {link.label}
            </button>
          );
        }

        return (
          <Link
            to={link.href || "#"}
            key={link.label}
            className={baseClassName}>
            {link.icon}
            {link.label}
          </Link>
        );
      })}
    </div>
  );
}
